// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"36100cc6","686":"415e8df9"}[chunkId] + ".chunk.css";
};